import { bookInfo } from '@libs/domain';
import { depreciationMethod } from '@libs/enums';
import { Item, SelectBoxField } from '@ps-smart-cp/ppfw-client';
import type { UsedBook } from '../context';
import type { BookDetail } from '../models';
import { createDepreciationMethod, getDepreciationMethodExcept } from '../services';

interface DepreciationMethodGroupProps<T extends { bookDetails: BookDetail[] }> {
  usedBooks: UsedBook[];
  obj: T;
  setObj: (t: T) => void;
  errorFields?: string[];
}

function DepreciationMethodGroup<T extends { bookDetails: BookDetail[] }>({
  usedBooks,
  obj,
  setObj,
  errorFields,
}: DepreciationMethodGroupProps<T>) {
  const except = getDepreciationMethodExcept();

  return usedBooks.map(({ bookName }, index) => (
    <SelectBoxField
      key={index}
      index={index}
      items={{
        depreciationMethod: Item.of(
          createDepreciationMethod(bookInfo.names.depreciationMethod, bookName),
          bookInfo.attributes.depreciationMethod,
        ),
      }}
      obj={obj.bookDetails[index]}
      setObj={(b: BookDetail) =>
        setObj({
          ...obj,
          bookDetails: obj.bookDetails.map((pre, i) => (i === index ? b : pre)),
        })
      }
      prop="depreciationMethod"
      enumNameConfig={depreciationMethod.nameConfig}
      enumType={depreciationMethod.enum}
      except={except}
      needEmptyOption
      needPrefix
      errorFields={errorFields}
    />
  ));
}

export { DepreciationMethodGroup };
